import { useMutation } from "@apollo/client"
import { UPDATE_ORG_ADDRESS } from "../graphql/mutations/updateOrganizationAddress"
import { GET_MY_ORGANIZATION } from "../graphql/queries/getMyOrganization"

export const useUpdateOrgAddress = ({ onCompleted, onError }) => {
  const [updateOrgAddress, { client, data, loading }] = useMutation(UPDATE_ORG_ADDRESS, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [GET_MY_ORGANIZATION],
  })

  return { updateOrgAddress, data, loading, client }
}
